module.exports = __webpack_public_path__ + "3b10afd608692049653a789981a35ff3.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Map/assets/marker.png
// module id = 2464
// module chunks = 0